/**
 * 获取本周、本季度、本月、上月的开始日期、结束日期
 */
function formatDate(date: Date, fmt: string) {
    date = (typeof date === 'number' || typeof date === 'string') ? new Date(date) : date;
    fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
    const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
        'H+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
    } as any;
    const week = {
        0: '\u65e5',
        1: '\u4e00',
        2: '\u4e8c',
        3: '\u4e09',
        4: '\u56db',
        5: '\u4e94',
        6: '\u516d'
    } as any;

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + '']);
    }

    for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }

    return fmt;
}

// 获得本月的开始日期
function getMonthStartDate() {
    const monthStartDate = new Date();
    return formatDate(monthStartDate, 'yyyy-MM-dd');
}

function dateMonth(termValidity: string, currentTime: string, sumMonth: number){
    const d1 = new Date(termValidity);// 有效期至
    const d2 = new Date(currentTime);// 当前日期
    if(sumMonth > 0){ // 2022/8/16 => 2022/11/16
        d2.setMonth((d2.getMonth()) + sumMonth);
    }
    if(d1.getTime() >= d2.getTime()){
        return true;
    }else{
        return false;
    }
}

export {getMonthStartDate, dateMonth}
